export default "__VITE_ASSET__DGqCC8Nb__"